import telegramIcon from '../../assets/icons/telegram.svg';
import githubIcon from '../../assets/icons/github.svg';

import { API_LINK, TELEGRAM_LINK, GITHUB_LINK } from '../../constants/links';

import styles from './styles.module.css';

export const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                <div className={styles.description}>
                    <div className={styles.title}>Art Institute of Chicago</div>
                    <div className={styles.text}>All the content based on <a href={API_LINK} className={styles.link}>Art Institute of Chicago’s open API</a></div>
                </div>
                <div className={styles.developer}>
                    <div className={styles.developerTitle}>Developed by:</div>
                    <a href={TELEGRAM_LINK} className={styles.contact}>
                        <img src={telegramIcon} alt="Telegram icon" className={styles.icon}/> 
                        <span>iwishyoujoy</span>
                    </a>
                    <a href={GITHUB_LINK} className={styles.contact}>
                        <img src={githubIcon} alt="Github icon" className={styles.icon}/> 
                        <span>iwishyoujoy</span>
                    </a>
                </div>
            </div>
        </footer>
    );
}